/* eslint-disable @typescript-eslint/ban-ts-comment */
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { interceptConfig } from '@/lib/client/config';
import { env } from '@/lib/env';
import Cookies from 'js-cookie';

const baseURL = env.NEXT_PUBLIC_GATEWAY_URL;

const publicApi = axios.create({
  baseURL: baseURL + '/webstore/public/v1',
});

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers = {
    ...config.headers,
    ...(process.env.NODE_ENV === 'development' ? { 'ngrok-skip-browser-warning': '1' } : {}),
    ...(Cookies.get('_partner_id') && Cookies.get('accessToken')
      ? { Authorization: `Bearer ${Cookies.get('accessToken')}` }
      : {}),
    ...(Cookies.get('_jstore_sid') ? { 'X-Jstore-Sid': Cookies.get('_jstore_sid') } : {}),
    ...(Cookies.get('_partner_id') ? { 'X-Partner-Id': Cookies.get('_partner_id') } : {}),
    ...(Cookies.get('_location_id') ? { 'X-Location-Id': Cookies.get('_location_id') } : {}),
  };

  // Only use for development mode only
  // this is for intercept request api gateway url to Local Dev
  if (process.env.NODE_ENV === 'development') {
    for (const intercept of interceptConfig.intercepts) {
      if (process.env.NODE_ENV === 'development')
        if (config.url?.startsWith(intercept.basepoint) && intercept.enable) {
          config.headers = {
            ...config.headers,
            ...(process.env.NODE_ENV === 'development'
              ? { 'ngrok-skip-browser-warning': '1' }
              : {}),
            'X-Jubelio-Intercept-Host': intercept.destinationHost,
            'X-Jubelio-Intercept-Scheme': intercept.destinationScheme,
          };
        }
    }
  }

  return config;
};

export const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

// @ts-ignore
publicApi.interceptors.request.use(onRequest, onRequestError);

export default publicApi;
